var map = {
	"./_dummy.jpg": 71,
	"./andrea-niggemann.jpg": 155,
	"./angelika-krebs.jpg": 156,
	"./anna-bourquin.jpg": 157,
	"./annka-dietrich.jpg": 158,
	"./chantal-metzger.jpg": 159,
	"./cover.jpg": 160,
	"./cover_mobile.jpg": 161,
	"./dorothea-jaeger.jpg": 162,
	"./felix-schlaefli.jpg": 163,
	"./isabel-jawdat.jpg": 164,
	"./isidor-huber.jpg": 165,
	"./kistemaker-madarena.jpg": 166,
	"./lars-haenggi.jpg": 167,
	"./marco-damico.jpg": 168,
	"./marco-liechti.jpg": 169,
	"./marion-mertens.jpg": 170,
	"./martin-schermesser.jpg": 171,
	"./monika-roeder.jpg": 172,
	"./paul-betschart.jpg": 173,
	"./paul-brunner.jpg": 174,
	"./philipp-howald.jpg": 175,
	"./sam-keller.jpg": 176,
	"./sergio-bustinduy.jpg": 177,
	"./stephan-wullschleger.jpg": 178,
	"./stephanie-girod.jpg": 179,
	"./sven-hugentobler.jpg": 180,
	"./ursi-senn.jpg": 181,
	"./vincent-gross.jpg": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;